import {LoadingIcon} from "assets/icon";
import {ButtonProps} from "../../types/types";

export default function Button({
                                   size = "df",
                                   disabled = false,
                                   loading = false,
                                   children,
                                   onClick,
                                   highlight = false,
                                   block = false,
                                   type = "button",
                                   rounded = true,
                                   className = '',
                                   style = {},
                                   dataset = {}
                               }: ButtonProps & { dataset?: { [key: string]: string } }) {

    const onAction = () => {
        if (!disabled && !loading) {
            onClick && onClick()
        }
    }
    return <button
        type={type}
        className={`${className} matchid-btn ${'matchid-btn-' + size} ${highlight ? "matchid-btn-highlight" : ''} ${loading ? "matchid-btn-loading" : ''}  ${block ? "matchid-btn-block" : ''}  ${rounded ? "matchid-btn-rounded" : ''}`}
        disabled={disabled || loading}
        style={{
            ...style
        }}
        onClick={onAction}
        {...dataset}
    >
        {
            loading ?
                <LoadingIcon className="matchid-btn-loading-icon" color="var(--matchid-btn-loading-color)"/> :
                children
        }
    </button>
}